import { IPreloadedState } from 'shared/types/redux';

export const selectRegions = (state: IPreloadedState) => state.regions;
